import { EntitiesColorsProvider } from 'contexts/EntitiesColorsContext'

import { useNicheChartsTabModel } from './niche-charts-tab.model'
import type { INicheChartsTabBaseProps } from './niche-charts-tab.types'
import { NicheChartsTabView } from './niche-charts-tab.view'

export const NicheChartsTab = (props: INicheChartsTabBaseProps) => {
  const nicheChartsTabModel = useNicheChartsTabModel(props)
  return (
    <EntitiesColorsProvider>
      <NicheChartsTabView {...nicheChartsTabModel} />
    </EntitiesColorsProvider>
  )
}
